// @flow
/** @jsx jsx */

import { AsyncIndicator } from '@zapier/common-components';
import { jsx } from '@emotion/core';

const style = {
  textAlign: 'center',
  padding: '15px 0px',
};

const SearchableFolderChooserLoader = () => (
  <div css={style}>
    <AsyncIndicator />
  </div>
);

export default SearchableFolderChooserLoader;
